<template>
  <SidebarComponent />
  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">

        <div class="titolo-card">
          <h1>Benvenuto nella tua gestione</h1>
        </div>
        <!-- Immagine centrata -->
        <div class="card-image">
          <img src="https://www.metodofusco.it/media/banner_grafici.png" alt="Descrizione dell'immagine">
        </div>

        <!-- Visibile a tutti -->
        <div class="card-header2" @click="goToConsulenze">
          <div class="icon-column">
            <span class="material-icons">video_camera_front</span>
          </div>
          <div class="text-column">
            <div class="header-text">Consulenze Tecniche e nutrizionali</div>
            <div class="text-card">Controlla le varie consulenze</div>
          </div>
          <div class="icon-column-right">
            <span class="material-icons">chevron_right</span>
          </div>
        </div>

        <div class="card-header2" @click="goToPercorsiNonIniziati">
          <div class="icon-column">
            <span class="material-icons">pending_actions</span>
          </div>
          <div class="text-column">
            <div class="header-text">Percorsi non iniziati</div>
            <div class="text-card">Utenti che hanno acquistato ma non hanno ancora compilato il questionario o check iniziale</div>
          </div>
          <div class="icon-column-right">
            <span class="material-icons">chevron_right</span>
          </div>
        </div>
        <div class="card-header2" role="link" tabindex="0" @click="goToTrainingBases" @keydown.enter="goToTrainingBases">
          <div class="icon-column"><span class="material-icons" aria-hidden="true">library_books</span></div>
          <div class="text-column"><div class="header-text">Basi allenamento</div><div class="text-card">Crea e organizza schede riutilizzabili per i programmi dei clienti</div></div>
          <div class="icon-column-right"><span class="material-icons" aria-hidden="true">chevron_right</span></div>
        </div>
        <router-link class="card-header2 programme-monitor-entry" :to="{ name: 'ProgrammeMonitor' }">
          <div class="icon-column"><span class="material-icons" aria-hidden="true">query_stats</span></div>
          <div class="text-column"><div class="header-text">Monitoraggio percorsi e nuovi acquisti</div><div class="text-card">Controlla l’avanzamento, i rinnovi già acquistati e gli utenti di ogni gruppo</div></div>
          <div class="icon-column-right"><span class="material-icons" aria-hidden="true">chevron_right</span></div>
        </router-link>
        <div
          class="card-header2"
          @click="goToInfluencerList"
        >
          <div class="icon-column">
            <span class="material-icons">whatshot</span>
          </div>
          <div class="text-column">
            <div class="header-text">Utenti Influencer</div>
            <div class="text-card">Elenco completo degli utenti con flag Influencer attivo</div>
          </div>
          <div class="icon-column-right">
            <span class="material-icons">chevron_right</span>
          </div>
        </div>

<!-- Visibile solo se userEmail corrisponde a valeriobianconi@gmail.com o robertacurto@gmail.com -->
<div
  class="card-header2"
  v-if="allowedEmails.includes(userEmail)"
  @click="goToAssistenza"
>
  <div class="icon-column">
    <span class="material-icons">fact_check</span>
  </div>
  <div class="text-column">
    <div class="header-text">Controllo Assistenza tecnica (Tickets)</div>
    <div class="text-card">Controlla i vari tickets</div>
  </div>
  <div class="icon-column-right">
    <span class="material-icons">chevron_right</span>
  </div>
</div>


<div
  class="card-header2"
  v-if="allowedEmails.includes(userEmail)"
  @click="goToProducts"
>
  <div class="icon-column">
    <span class="material-icons">fact_check</span>
  </div>
  <div class="text-column">
    <div class="header-text">Prodotti</div>
    <div class="text-card">Controlla i vari prodotti</div>
  </div>
  <div class="icon-column-right">
    <span class="material-icons">chevron_right</span>
  </div>
</div>

<div
  class="card-header2"
  v-if="allowedEmails.includes(userEmail)"
  @click="goToProdottiAcquistati"
>
  <div class="icon-column">
    <span class="material-icons">shopping_bag</span>
  </div>
  <div class="text-column">
    <div class="header-text">Prodotti acquistati</div>
    <div class="text-card">Recupera i prodotti acquistati (WooCommerce, legacy, manuali)</div>
  </div>
  <div class="icon-column-right">
    <span class="material-icons">chevron_right</span>
  </div>
</div>

<div
  class="card-header2"
  v-if="allowedEmails.includes(userEmail)"
  @click="goToOrdiniPtExport"
>
  <div class="icon-column">
    <span class="material-icons">fitness_center</span>
  </div>
  <div class="text-column">
    <div class="header-text">Ordini PT export</div>
    <div class="text-card">Ricerca ed esporta ordini con sedute PT</div>
  </div>
  <div class="icon-column-right">
    <span class="material-icons">chevron_right</span>
  </div>
</div>

<div
  class="card-header2"
  v-if="allowedEmails.includes(userEmail)"
  @click="goToLinkClicksAnalytics"
>
  <div class="icon-column">
    <span class="material-icons">insights</span>
  </div>
  <div class="text-column">
    <div class="header-text">Tracking link esterni</div>
    <div class="text-card">Analisi click e copia link tracciati</div>
  </div>
  <div class="icon-column-right">
    <span class="material-icons">chevron_right</span>
  </div>
</div>

<div
  class="card-header2"
  v-if="allowedEmails.includes(userEmail)"
  @click="goToAcquirentiProdottiLista"
>
  <div class="icon-column">
    <span class="material-icons">playlist_add_check</span>
  </div>
  <div class="text-column">
    <div class="header-text">Acquirenti prodotti lista</div>
    <div class="text-card">Utenti con almeno 2 prodotti distinti della lista</div>
  </div>
  <div class="icon-column-right">
    <span class="material-icons">chevron_right</span>
  </div>
</div>


<div
  class="card-header2"
  v-if="allowedEmails.includes(userEmail)"
  @click="goToRecuperoAccountDoppi"
>
  <div class="icon-column">
    <span class="material-icons">people_alt</span>
  </div>
  <div class="text-column">
    <div class="header-text">Account doppi</div>
    <div class="text-card">Verifica e unisci gli account duplicati</div>
  </div>
  <div class="icon-column-right">
    <span class="material-icons">chevron_right</span>
  </div>
</div>

<div
  class="card-header2"
  v-if="allowedEmails.includes(userEmail)"
  @click="goToRecuperoTicketDoppi"
>
  <div class="icon-column">
    <span class="material-icons">content_copy</span>
  </div>
  <div class="text-column">
    <div class="header-text">Ticket duplicati</div>
    <div class="text-card">Individua e unisci i ticket tecnici doppi</div>
  </div>
  <div class="icon-column-right">
            <span class="material-icons">chevron_right</span>
          </div>
        </div>

        <div class="card-header2" @click="goToPublicBookings">
          <div class="icon-column">
            <span class="material-icons">event_available</span>
          </div>
          <div class="text-column">
            <div class="header-text">Prenotazioni pubbliche</div>
            <div class="text-card">Visualizza le prenotazioni video call arrivate dalla landing</div>
          </div>
          <div class="icon-column-right">
            <span class="material-icons">chevron_right</span>
          </div>
        </div>

<!--<div
  class="card-header2"
  v-if="allowedEmails.includes(userEmail)"
  @click="goToTemplate"
>
  <div class="icon-column">
    <span class="material-icons">fact_check</span>
  </div>
  <div class="text-column">
    <div class="header-text">Questionari template</div>
    <div class="text-card">Controlla i vari template</div>
  </div>
  <div class="icon-column-right">
    <span class="material-icons">chevron_right</span>
  </div>
</div>



<div
  class="card-header2"
  v-if="allowedEmails.includes(userEmail)"
  @click="goToQuestionari"
>
  <div class="icon-column">
    <span class="material-icons">fact_check</span>
  </div>
  <div class="text-column">
    <div class="header-text">Questionari utenti</div>
    <div class="text-card">Controlla e approva i vari questionari</div>
  </div>
  <div class="icon-column-right">
    <span class="material-icons">chevron_right</span>
  </div>
</div>-->

<div
  class="card-header2"
  v-if="allowedEmails.includes(userEmail)"
  @click="goToQuestionariUidFix"
>
  <div class="icon-column">
    <span class="material-icons">link_off</span>
  </div>
  <div class="text-column">
    <div class="header-text">Questionari senza utente</div>
    <div class="text-card">Riassegna UID a questionari/check orfani</div>
  </div>
  <div class="icon-column-right">
    <span class="material-icons">chevron_right</span>
  </div>
</div>

<div
  class="card-header2"
  v-if="allowedEmails.includes(userEmail)"
  @click="goToConsulenzeTecnicheScalata"
>
  <div class="icon-column">
    <span class="material-icons">rule_folder</span>
  </div>
  <div class="text-column">
    <div class="header-text">Scalata consulenze tecniche</div>
    <div class="text-card">Scansiona, applica e ripristina le consulenze tecniche con check finale fatto</div>
  </div>
  <div class="icon-column-right">
    <span class="material-icons">chevron_right</span>
  </div>
</div>

<div
  class="card-header2"
  v-if="allowedEmails.includes(userEmail)"
  @click="goToImportProgramHistory"
>
  <div class="icon-column">
    <span class="material-icons">upload_file</span>
  </div>
  <div class="text-column">
    <div class="header-text">Import percorsi storici</div>
    <div class="text-card">Carica percorsi e scadenze da CSV</div>
  </div>
  <div class="icon-column-right">
    <span class="material-icons">chevron_right</span>
  </div>
</div>



<div
  class="card-header2"
  v-if="allowedEmails.includes(userEmail)"
  @click="goToImportWoocommerce"
>
  <div class="icon-column">
    <span class="material-icons">upload_file</span>
  </div>
  <div class="text-column">
    <div class="header-text">Importa Ordini Woocommerce</div>
    <div class="text-card">Carica manualmente gli ordini</div>
  </div>
  <div class="icon-column-right">
    <span class="material-icons">chevron_right</span>
  </div>
</div>

<div
  class="card-header2 email-normalizer"
  v-if="allowedEmails.includes(userEmail)"
>
  <div class="icon-column">
    <span class="material-icons">alternate_email</span>
  </div>
  <div class="text-column">
    <div class="header-text">Normalizza email (minuscole)</div>
    <div class="text-card">Controlla e correggi le email in users e orders.</div>
    <div v-if="emailNormalization.status" class="email-normalizer__status">
      {{ emailNormalization.status }}
    </div>
    <div v-if="emailNormalization.error" class="email-normalizer__error">
      {{ emailNormalization.error }}
    </div>
    <div v-if="emailNormalization.results" class="email-normalizer__results">
      <div v-for="(res, key) in emailNormalization.results" :key="key">
        <strong>{{ key }}</strong> · controllati {{ res.scanned }} · maiuscole {{ res.uppercase }} · aggiornati {{ res.updated }} · invariati {{ res.unchanged }}
        <details v-if="res.samples && res.samples.length" class="email-normalizer__samples">
          <summary>Mostra {{ res.samples.length }} email con maiuscole</summary>
          <ul>
            <li v-for="(sample, idx) in res.samples" :key="`${key}-${idx}`">{{ sample }}</li>
          </ul>
          <div v-if="res.sampleOverflow" class="email-normalizer__note">
            Lista troncata a {{ res.sampleLimit }} voci.
          </div>
        </details>
      </div>
    </div>
  </div>
  <div class="icon-column-right email-normalizer__actions">
    <button
      type="button"
      class="create-user-button staff-button-neutral"
      :disabled="emailNormalization.running"
      @click="runEmailNormalization(true)"
    >
      Controlla
    </button>
    <button
      type="button"
      class="create-user-button danger staff-button-danger"
      :disabled="emailNormalization.running"
      @click="runEmailNormalization(false)"
    >
      Normalizza
    </button>
  </div>
</div>


      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import { ref, onMounted, reactive } from 'vue';
import { getAuth, signOut } from 'firebase/auth';
import {
  getFirestore,
  collection,
  query,
  orderBy,
  limit,
  startAfter,
  getDocs,
  writeBatch
} from 'firebase/firestore';
import SidebarComponent from '../SidebarComponent.vue';

export default {
  name: "DashboardHome",
  components: {
    SidebarComponent
  },
  setup() {
    const router = useRouter();
    const db = getFirestore();

    const userEmail = ref('');
    const allowedEmails = ['valeriobianconi@gmail.com', 'robertacurto@fusco.fit','assistenza@be-better.fit' ];
    const DOCUMENT_ID = '__name__';
    const EMAIL_BATCH_SIZE = 350;

    const emailNormalization = reactive({
      running: false,
      status: '',
      error: '',
      results: null
    });


    // Al montaggio, recuperiamo l'utente attualmente autenticato
    onMounted(() => {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (currentUser) {
        userEmail.value = (currentUser.email || '').toLowerCase();
      }
    });

    const goToConsulenze = () => {
      router.push('/consulenze-riepilogo');
    };

    const goToPercorsiNonIniziati = () => {
      router.push('/percorsi-non-iniziati');
    };

    const goToTrainingBases = () => {
      router.push({ name: 'TrainingBases' });
    };

    const goToInfluencerList = () => {
      router.push('/users-influencer-list');
    };

    const goToPublicBookings = () => {
      router.push('/prenotazioni-pubbliche');
    };

    const goToAssistenza = () => {
      router.push('/assistenzatecnica-nascosta');
    };

        const goToProducts = () => {
      router.push('/products');
    };

        const goToProdottiAcquistati = () => {
      router.push('/prodotti-acquistati');
    };

    const goToOrdiniPtExport = () => {
      router.push('/ordini-pt-export');
    };

    const goToLinkClicksAnalytics = () => {
      router.push('/link-click-analytics');
    };

        const goToAcquirentiProdottiLista = () => {
      router.push('/acquirenti-prodotti-lista');
    };

                const goToTemplate = () => {
      router.push('/questionari-template');
    };

                const goToQuestionari = () => {
      router.push('/questionari-users');
    };

                const goToQuestionariUidFix = () => {
      router.push('/questionari-uid-fix');
    };

                const goToConsulenzeTecnicheScalata = () => {
      router.push('/consulenze-tecniche-scalata');
    };

                const goToRecuperoAccountDoppi = () => {
      router.push('/recuperoaccountdoppi');
    };

            const goToRecuperoTicketDoppi = () => {
      router.push('/recuperoticketdoppi');
    };

            const goToImportProgramHistory = () => {
      router.push('/import-program-history');
    };

    const goToImportWoocommerce = () => {
      router.push('/import-orders');
            };

    const normalizeEmailValue = (value) => {
      if (!value) return '';
      return String(value).trim().toLowerCase();
    };

    const EMAIL_SAMPLE_LIMIT = 200;

    const normalizeCollectionEmails = async (target, dryRun = true) => {
      let cursor = null;
      const totals = {
        scanned: 0,
        uppercase: 0,
        updated: 0,
        unchanged: 0,
        samples: [],
        sampleLimit: EMAIL_SAMPLE_LIMIT,
        sampleOverflow: false
      };
      const sampleKeys = new Set();

      let keepGoing = true;
      while (keepGoing) {
        let q = query(
          collection(db, target.collection),
          orderBy(DOCUMENT_ID),
          limit(EMAIL_BATCH_SIZE)
        );
        if (cursor) {
          q = query(q, startAfter(cursor));
        }

        const snap = await getDocs(q);
        if (snap.empty) {
          keepGoing = false;
          break;
        }

        const batch = writeBatch(db);
        let batchWrites = 0;

        snap.forEach((docSnap) => {
          totals.scanned += 1;
          const data = docSnap.data() || {};
          const updates = {};
          let hasUppercase = false;

          target.fields.forEach((field) => {
            const raw = data[field];
            if (typeof raw !== 'string' || !raw.trim()) return;
            const normalized = normalizeEmailValue(raw);
            const rawLower = raw.toLowerCase();
            const hasUpper = raw !== rawLower;
            if (hasUpper) {
              hasUppercase = true;
              if (normalized && normalized !== raw) {
                updates[field] = normalized;
              }
              if (dryRun && totals.samples.length < EMAIL_SAMPLE_LIMIT) {
                const label = `${field}: ${raw.trim()}`;
                if (!sampleKeys.has(label)) {
                  totals.samples.push(label);
                  sampleKeys.add(label);
                }
              } else if (dryRun && totals.samples.length >= EMAIL_SAMPLE_LIMIT) {
                totals.sampleOverflow = true;
              }
            }
          });

          if (hasUppercase) {
            totals.uppercase += 1;
          }

          if (Object.keys(updates).length) {
            totals.updated += 1;
            if (!dryRun) {
              batch.update(docSnap.ref, updates);
              batchWrites += 1;
            }
          } else {
            totals.unchanged += 1;
          }
        });

        if (!dryRun && batchWrites > 0) {
          await batch.commit();
        }

        cursor = snap.docs[snap.docs.length - 1];
        if (snap.size < EMAIL_BATCH_SIZE) {
          keepGoing = false;
          break;
        }
      }

      return totals;
    };

    const runEmailNormalization = async (dryRun = true) => {
      if (!allowedEmails.includes(userEmail.value)) return;
      if (!dryRun) {
        const confirmed = window.confirm('Confermi la normalizzazione delle email in users e orders?');
        if (!confirmed) return;
      }

      emailNormalization.running = true;
      emailNormalization.error = '';
      emailNormalization.results = null;
      emailNormalization.status = dryRun ? 'Controllo in corso…' : 'Normalizzazione in corso…';

      try {
        const targets = [
          { label: 'users', collection: 'users', fields: ['email'] },
          { label: 'orders', collection: 'orders', fields: ['userEmail', 'customerEmail'] }
        ];

        const results = {};
        for (const target of targets) {
          emailNormalization.status = `${dryRun ? 'Controllo' : 'Normalizzazione'} ${target.label}…`;
          // eslint-disable-next-line no-await-in-loop
          results[target.label] = await normalizeCollectionEmails(target, dryRun);
        }

        emailNormalization.results = results;
        emailNormalization.status = dryRun ? 'Controllo completato.' : 'Normalizzazione completata.';
      } catch (error) {
        console.error('Errore normalizzazione email:', error);
        emailNormalization.error = 'Errore durante la normalizzazione. Controlla la console.';
        emailNormalization.status = '';
      } finally {
        emailNormalization.running = false;
      }
    };
    

    const handleLogout = async () => {
      const auth = getAuth();
      try {
        await signOut(auth);
        router.push('/');
      } catch (error) {
        console.error("Errore durante il logout:", error);
      }
    };

    return {
      userEmail,
      goToConsulenze,
      goToPercorsiNonIniziati,
      goToTrainingBases,
      goToInfluencerList,
      goToPublicBookings,
      goToAssistenza,
      handleLogout,
      allowedEmails,
      goToProducts,
      goToProdottiAcquistati,
      goToOrdiniPtExport,
      goToLinkClicksAnalytics,
      goToAcquirentiProdottiLista,
      goToRecuperoAccountDoppi,
      goToRecuperoTicketDoppi,
      goToTemplate,
      goToQuestionari,
      goToQuestionariUidFix,
      goToConsulenzeTecnicheScalata,
      goToImportProgramHistory,
      goToImportWoocommerce,
      runEmailNormalization,
      emailNormalization
    };
  }
};
</script>

<style scoped>

.card-image img {
  max-width: 100%;
  border-radius: 8px;
}
.card-header2 {
  display: flex;
  cursor: pointer;
  margin: 10px 0;
  padding: 10px;
  background-color: #f7f7f7;
  border-radius: 8px;
  align-items: center;
}
.email-normalizer {
  cursor: default;
  align-items: flex-start;
  gap: 10px;
}
.programme-monitor-entry { color:inherit; text-decoration:none; }
.programme-monitor-entry:focus-visible { outline:3px solid #7699af; outline-offset:3px; }
.email-normalizer__actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-end;
}
.email-normalizer__status {
  margin-top: 6px;
  font-size: 0.85rem;
  color: #374151;
}
.email-normalizer__error {
  margin-top: 6px;
  font-size: 0.85rem;
  color: #b91c1c;
}
.email-normalizer__results {
  margin-top: 6px;
  font-size: 0.85rem;
  color: #374151;
}
.email-normalizer__samples {
  margin-top: 6px;
}
.email-normalizer__samples summary {
  cursor: pointer;
  font-weight: 600;
  color: #1f2937;
}
.email-normalizer__samples ul {
  margin: 6px 0 0;
  padding-left: 18px;
  max-height: 220px;
  overflow: auto;
}
.email-normalizer__note {
  margin-top: 6px;
  font-size: 0.8rem;
  color: #6b7280;
}
.icon-column {
  flex: 0 0 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.text-column {
  flex: 1;
  margin-left: 10px;
}
.icon-column-right {
  flex: 0 0 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.header-text {
  font-weight: bold;
}
.text-card {
  font-size: 0.9rem;
  color: #555;
}
</style>
